"use strict";
//
// Copyright © 2025 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatalakeStorage = void 0;
const core_1 = require("@hcengineering/core");
const upload_1 = require("../upload");
const getPathname = (url) => {
    const base = window?.location?.href ?? 'http://localhost';
    return new URL(url, base).pathname;
};
/** @public */
class DatalakeStorage {
    baseUrl;
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    getFileUrl(workspace, file, filename) {
        if (filename !== undefined && filename !== '') {
            const encodedFilename = encodeURIComponent(filename);
            const path = `/blob/${workspace}/${file}/${encodedFilename}`;
            return (0, core_1.concatLink)(this.baseUrl, path);
        }
        const path = `/blob/${workspace}/${file}`;
        return (0, core_1.concatLink)(this.baseUrl, path);
    }
    getCookiePath(workspace) {
        const url = (0, core_1.concatLink)(this.baseUrl, `/blob/${workspace}`);
        return getPathname(url);
    }
    async getFileMeta(token, workspace, file) {
        const url = (0, core_1.concatLink)(this.baseUrl, `/meta/${encodeURIComponent(workspace)}/${encodeURIComponent(file)}`);
        try {
            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.ok) {
                return await response.json();
            }
        }
        catch (err) { }
        return {};
    }
    async deleteFile(token, workspace, file) {
        const url = this.getFileUrl(workspace, file);
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Failed to delete file');
        }
    }
    async uploadFile(token, workspace, uuid, file, options) {
        if (file.size <= 10 * 1024 * 1024) {
            const formData = new FormData();
            formData.append('file', file, uuid);
            await (0, upload_1.uploadXhr)({
                url: (0, core_1.concatLink)(this.baseUrl, `/upload/form-data/${encodeURIComponent(workspace)}`),
                method: 'POST',
                headers: { Authorization: `Bearer ${token}` },
                body: formData
            }, options);
        }
        else {
            const url = (0, core_1.concatLink)(this.baseUrl, `/upload/multipart/${encodeURIComponent(workspace)}/${encodeURIComponent(uuid)}`);
            const headers = { Authorization: `Bearer ${token}` };
            await (0, upload_1.uploadMultipart)({ url, headers, body: file }, options);
        }
    }
}
exports.DatalakeStorage = DatalakeStorage;
//# sourceMappingURL=datalake.js.map